import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { FilterModel } from '@ui/shared/util-filter';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-filter-banner',
    templateUrl: './filter-banner.component.html',
    styleUrls: ['./filter-banner.component.scss'],
    standalone: false,
})
export class FilterBannerComponent {
    public title = '';
    public values = '';

    @Input()
    public set filter(filter: FilterModel) {
        this.title = filter.title;

        this.values = filter.values
            .map(value => value.label)
            .join(', ');
    }
}
